<script setup>
    import { router } from '@inertiajs/vue3';
    import AppLayout from '@/Layouts/AppLayout.vue';
    import DashboardSidebar from '@/Jetstream/DashboardSidebar.vue';
    import JetButton from '@/Jetstream/Button.vue';
    import { ref } from 'vue';

    // includes we need to front end locale magic
    import { useI18n } from 'vue-i18n';
    // Get locale as set in cookie
    let { locale } = useI18n({ useScope: 'global' });

    const props = defineProps({
        activeToolkits: Array,
        previousToolkits: Array,
        loggedInUser: Object,
    });

    const programme = router.page.props.ziggy.programme;
    const organisation = router.page.props.ziggy.organisation;
    const urlNamePrefix = organisation ? "gi." : "";

    const organisation_name = (programme.organisation_custom_name && programme.organisation_custom_name.length == 0) ? programme.organisation_custom_name : 'Organisation' ;
    //const team_name = (programme.organisation_custom_name && programme.team_custom_name.length == 0) ? programme.team_custom_name : 'Team' ;

    let team_custom_name = programme.team_custom_name;
    if (team_custom_name) {
        if(team_custom_name.constructor.name != 'Object') {
            team_custom_name = JSON.parse(team_custom_name);
        }
    }

    let default_team_name;

    if (locale.value == 'cy') {
        default_team_name = 'tîm';

    } else  {
        default_team_name = 'team';
    }

    let team_name = default_team_name;

    if (team_custom_name) {
        team_name =  team_custom_name[locale.value] == null ? default_team_name : team_custom_name[locale.value];
    }



    const anyToolkits = props.activeToolkits.length > 0 ? true : false;
    const anyPastToolkits = props.previousToolkits.length > 0 ? true : false;
    const default_text = router.page.props.ziggy.default_text;
    const enabling = ref(false);

    const convertToObject = (json) => {
        if (json.constructor.name != 'Object') {
            json = JSON.parse(json)
        }
        return json;
    }

    let no_toolkits_text = null;

    if (default_text) {
        no_toolkits_text = default_text.filter((item) => {
            return item.key == "no_toolkits";
        });
        no_toolkits_text = no_toolkits_text[0];
        if (no_toolkits_text) {
            no_toolkits_text = convertToObject(no_toolkits_text);
        }
    }

    const teamJoin = (toolkit_id) => {
        enabling.value = true;
        router.put(route(urlNamePrefix+'toolkit-team.join'),
        {
            toolkit_id: toolkit_id,
            team_id: props.loggedInUser.current_team.id
        }, {
            onSuccess: page => {
                enabling.value = false;
            },
            onError: (errors) => {
                enabling.value = false;
            },
        });
    }

    const retractSubmission = (teamToolkitId) => {
        enabling.value = true;
        router.put(route(urlNamePrefix+'toolkit-team.retract'),
        {
            team_toolkit_id: teamToolkitId,
            team_id: props.loggedInUser.current_team.id
        }, {
            onSuccess: page => {
                enabling.value = false;
            },
            onError: (errors) => {
                enabling.value = false;
            },
        });
    }

if (organisation && organisation.no_toolkits) {
    organisation.no_toolkits = convertToObject(organisation.no_toolkits)
}

if (programme.no_toolkits) {
    programme.no_toolkits = convertToObject(programme.no_toolkits)
}

// Remove duplicates from previous toolkits list.
// const previousToolkits = props.previousToolkits.reverse();
// const activeToolkits = props.activeToolkits.reverse();

</script>


<template>
    <AppLayout title="Toolkit">
        <div class="container mx-auto flex flex-col lg:flex-row justify-between w-full">

            <div id="sos-programme-dashboard-sidebar" class="order-2 lg:order-1 w-full lg:w-1/4 xl:w-1/5 min-h-screen p-10 pt-5">
                <DashboardSidebar />
            </div>

            <div class="order-1 lg:order-2 w-full lg:w-3/4 xl:w-4/5 sos-programme-dashboard-content">
                <div class="overflow-hidden pl-10 mb-10 pr-10 lg:pr-0 pt-3">
                    <div id="toolkit-header">
                        <div class="w-full">
                            <h1 class="dashboard-title pt-5">{{ $t('toolkit.toolkit') }}</h1>
                            <p class="font-bold"><span style="text-transform: capitalize;">{{ $t( team_name ) }}</span>: {{ $page.props.auth.user.current_team.name}}</p>
                        </div>
                        <div class="w-full">
                            <h2>{{ $t('toolkit.join.title') }}</h2>
                            <div v-if="!anyToolkits">
                                <div v-if="organisation">
                                    <div v-if="organisation.no_toolkits && organisation.no_toolkits[$i18n.locale]" v-html="organisation.no_toolkits[$i18n.locale]"></div>
                                    <div v-else-if="(!organisation.no_toolkits || !organisation.no_toolkits[$i18n.locale]) && (programme.no_toolkits && programme.no_toolkits[$i18n.locale])" v-html="programme.no_toolkits[$i18n.locale]"></div>
                                    <div v-else-if="(no_toolkits_text && no_toolkits_text.content && no_toolkits_text.content[$i18n.locale]) && (!organisation.no_toolkits || !organisation.no_toolkits[$i18n.locale]) && (!programme.no_toolkits || !programme.no_toolkits[$i18n.locale])" v-html="no_toolkits_text.content[$i18n.locale]"></div>
                                    <div v-else>
                                        <p>{{ $t('toolkit.no_toolkits') }}</p>
                                    </div>
                                </div>

                                <div v-if="!organisation">
                                    <div v-if="programme.no_toolkits && programme.no_toolkits[$i18n.locale]" v-html="programme.no_toolkits[$i18n.locale]"></div>
                                    <div v-else-if="(no_toolkits_text && (no_toolkits_text.content && no_toolkits_text.content[$i18n.locale])) && (!programme.no_toolkits || !programme.no_toolkits[$i18n.locale])" v-html="no_toolkits_text.content[$i18n.locale]"></div>
                                    <div v-else>
                                        <p>{{ $t('toolkit.no_toolkits') }}</p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="anyToolkits" v-for="activeToolkit in activeToolkits">
                                <JetButton type="button" :class="{ 'opacity-25': enabling }" :disabled="enabling" v-on:click="teamJoin(activeToolkit.id)">
                                    {{ $t('toolkit.join.button') }}: {{activeToolkit.name}} ({{activeToolkit.type}})
                                </JetButton>
                            </div>
                        </div>
                        <!-- <div class="w-full" style="margin-top: 20px;">
                            <h2>{{ $t('toolkit.past.title') }}</h2>
                            <p v-if="!anyPastToolkits">{{ $t('toolkit.past.none', { team_name: team_name }) }}</p>
                            <div v-if="anyPastToolkits" v-for="previousToolkit in previousToolkits">
                                <div v-if="previousToolkit.active == 1">
                                <JetButton type="button" :class="[{ 'opacity-25': enabling }, 'float-right']" v-if="previousToolkit.retractable" v-on:click="retractSubmission(previousToolkit.teamToolkitId)">
                                    {{ $t('toolkit.past.retract') }}
                                </JetButton>
                                <a type="button" :class="[{ 'opacity-25': enabling }, 'float-right']" :href="route(urlNamePrefix+'past-toolkit.view', {programme:programme.slug, organisation:organisation.slug, toolkit:previousToolkit.id})">
                                    {{ $t('toolkit.past.view') }}
                                </a>
                                <h3 style="margin-bottom: 10px;">{{previousToolkit.name}} ({{ team_name }})</h3>
                                <p class="italic">
                                    <span v-if="previousToolkit.toolkit_status">
                                        <span class="font-bold">{{ $t('toolkit.past.status') }}:</span> {{previousToolkit.toolkit_status}}
                                    </span>
                                    <br />
                                    <span v-if="previousToolkit.toolkit_actions">
                                        <span class="font-bold">{{ $t('toolkit.past.actions') }}:</span> {{previousToolkit.toolkit_actions}}
                                    </span>
                                    <br />
                                    <span v-if="(previousToolkit.score > 0)">
                                        <span class="font-bold">{{ $t('toolkit.past.score') }}:</span> {{previousToolkit.score}}
                                    </span>
                                </p>
                                <hr />
                            </div>
                        </div> -->

                        <!-- <div class="w-full">
                            <h1 class="dashboard-title pt-5">Past Toolkits</h1>
                            <p class="font-bold">Team: {{ $page.props.auth.user.current_team.name}}</p>
                            <p v-if="props.activeToolkit === null">There are currently no active Toolkits avilable to join. Please check back later.</p>
                        </div> -->

                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>
